import moment from 'moment'

/**
 * Helpers for the masked `##/##/####` date inputs used across the app.
 *
 * They exist because `moment(value, 'DD/MM/YYYY')` parses non-strictly: a user
 * who types `12/05/27` into the mask gets year 27 (0027-05-12), which formats
 * to a string the backend `date` rule rejects. Parse strictly, expand the
 * shorthand year first, and surface a message instead of posting garbage.
 */
export const DATE_INPUT_FORMAT = 'DD/MM/YYYY'

/**
 * Expand what was typed into a full dd/mm/yyyy string. Only the unambiguous
 * 2-digit year case is expanded (`12/05/27` -> `12/05/2027`); anything else is
 * returned untouched so the validator can reject it rather than guess.
 */
export function normalizeDateInput(value) {
  if (value === null || value === undefined) return value
  const raw = String(value).trim()
  if (!raw) return raw
  const parts = raw.match(/^(\d{1,2})\/(\d{1,2})\/(\d{2}|\d{4})$/)
  if (!parts) return raw
  const [, day, month, year] = parts
  const fullYear = year.length === 2 ? `20${year}` : year
  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${fullYear}`
}

/** Strict dd/mm/yyyy -> moment. Unparseable input yields an invalid moment. */
export function parseDateInput(value) {
  return moment(normalizeDateInput(value), DATE_INPUT_FORMAT, true)
}

export function isValidDateInput(value) {
  return parseDateInput(value).isValid()
}

/** Strict dd/mm/yyyy -> `YYYY-MM-DD` for the API, or null when unparseable. */
export function toApiDate(value) {
  const parsed = parseDateInput(value)
  return parsed.isValid() ? parsed.format('YYYY-MM-DD') : null
}
